const SOUND_FILE = "/assets/sound/sound.wav";

const audio = new Audio(SOUND_FILE);
audio.preload = "auto";
audio.load();

let unlocked = false;

const unlockAudio = () => {
  if (unlocked) return;
  const p = audio.play();
  if (p && typeof p.then === "function") {
    p.then(() => {
      audio.pause();
      audio.currentTime = 0;
      unlocked = true;
    }).catch((err) => {
      console.warn("[soundService] unlock attempt failed:", err);
    });
  } else {
    unlocked = true;
  }
};

export const playSound = () => {
  try {
    audio.pause();
    audio.currentTime = 0;
    const p = audio.play();
    if (p && typeof p.catch === "function") {
      p.catch((err) => {
        console.warn("[soundService] play failed:", err && err.name, err && err.message);
      });
    }
  } catch (err) {
    console.warn("[soundService] play threw:", err);
  }
};

if (typeof document !== "undefined") {
  const onFirstInteract = () => {
    unlockAudio();
    document.removeEventListener("click", onFirstInteract);
    document.removeEventListener("keydown", onFirstInteract);
    document.removeEventListener("touchstart", onFirstInteract);
  };
  document.addEventListener("click", onFirstInteract);
  document.addEventListener("keydown", onFirstInteract);
  document.addEventListener("touchstart", onFirstInteract);
}
